export class ItemOrderRequest {

    constructor(public itemId: number, public displayOrder: number) {}

    public static of(itemId: number, displayOrder: number) {
        return new ItemOrderRequest(itemId, displayOrder);
    }
}
